import { render, staticRenderFns } from "./SingleOrderItem.vue?vue&type=template&id=6815b0a4&"
import script from "./SingleOrderItem.vue?vue&type=script&lang=js&"
export * from "./SingleOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrderItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports